import { onBeforeUnmount, onMounted, ref, type Ref } from 'vue';

/**
 * The current time as reactive state, refreshed on every full minute. Today's
 * highlight and the now line are state, not constants: a calendar left open
 * overnight must move both, and one timer per view is enough for that.
 */
export function useNow(): Ref<Date> {
  const now = ref(new Date());
  let timer: ReturnType<typeof setTimeout> | undefined;

  function schedule(): void {
    const current = new Date();
    // A second past the minute, so the clock has certainly turned over.
    const wait = (60 - current.getSeconds()) * 1000 - current.getMilliseconds() + 1000;
    timer = setTimeout(() => {
      now.value = new Date();
      schedule();
    }, wait);
  }

  onMounted(schedule);
  onBeforeUnmount(() => clearTimeout(timer));
  return now;
}
